import { MouseEvent, useCallback, useState } from 'react';
import { find } from 'lodash-es';

import { ICheckin } from 'src/interfaces/Checkin';
import { IEnrichedParticipant, IParticipant } from 'src/interfaces/Participant';

export function useCheckinModalState(participants: IParticipant[]) {
  const [open, setOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState<
    IParticipant | IEnrichedParticipant | undefined
  >();
  const [newCheckin, setNewCheckin] = useState<ICheckin | undefined>();

  const openCheckin = useCallback(
    (id?: string, e?: MouseEvent<unknown>) => {
      e?.stopPropagation();
      if (!id) {
        return;
      }
      const participant = find(participants, { id });
      if (participant) {
        setSelectedParticipant(participant);
        setOpen(true);
      }
    },
    [participants],
  );

  /** Open with a known participant (e.g. right after registration create). */
  const openCheckinForParticipant = useCallback(
    (participant: (Partial<IParticipant> & { id: string }) | IEnrichedParticipant) => {
      setSelectedParticipant(participant as IEnrichedParticipant);
      setOpen(true);
    },
    [],
  );

  const closeCheckin = useCallback(() => {
    setSelectedParticipant(undefined);
    setOpen(false);
  }, []);

  const clearNewCheckin = useCallback(() => {
    setNewCheckin(undefined);
  }, []);

  return {
    checkinModalOpen: open,
    selectedCheckinParticipant: selectedParticipant,
    newCheckin,
    setNewCheckin,
    openCheckin,
    openCheckinForParticipant,
    closeCheckin,
    clearNewCheckin,
  };
}
